import markerImage from '../../images/marker.png';

class GMap {
    constructor() {
        document.querySelectorAll(".google-map").forEach(el => {
            this.new_map(el)
        })
    }

    new_map($el) {
        var styles = [
            {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'administrative.land_parcel',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'administrative.neighborhood',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'poi',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'labels.text',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'transit',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
        ]

        var pos = {
            lat: 49.786770613713244,
            lng: 19.20064949084523,
        }

        var args = {
            zoom: 16,
            center: pos,
            mapTypeId: 'mystyle',
        }

        var map = new google.maps.Map($el, args)
        map.markers = []
        this.add_marker(map);

        var that = this

        map.mapTypes.set(
            'mystyle',
            new google.maps.StyledMapType(styles, {name: 'megisport.pl style'}),
        )

    }

    add_marker(map) {
        var latlng = new google.maps.LatLng(
            49.786170613713244,
            19.20079949084523
        )


        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: markerImage,
        })

        google.maps.event.addListener(marker, "click", function () {
            window.open("https://www.google.com/maps/place/Pla%C5%BCa+Miedzybrodzie", '_blank').focus();
        })


        // // if marker contains HTML, add it to an infoWindow
        // if ($marker.innerHTML) {
        //     // create info window
        //     var infowindow = new google.maps.InfoWindow({
        //         content: $marker.innerHTML
        //     })
        //
        //     // show info window when marker is clicked
        //     google.maps.event.addListener(marker, "click", function () {
        //         infowindow.open(map, marker)
        //     })
        // }
    } // end add_marker
}

export default GMap
